import React, { PureComponent } from "react";

import { Metric, Error } from "../../Utils/Utils.js";
import Heading from "../../Elements/Heading.js";

class PageEngagement extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    if (data.page_views_per_visitor_last7) {
      data.page_views_per_visitor_last7.forEach((d) => (d.label = d.date));
      data.page_views_per_visitor_last7 = data.page_views_per_visitor_last7.reverse();
    }

    if (data.avg_time_spent_last7) {
      data.avg_time_spent_last7.forEach((d) => {
        d.label = d.date;
        d.displayedValue = d.value;
        if (d.value && d.value.length) {
          const t = d.value.split(":").map((d) => parseInt(d, 10));
          d.value = t.length > 1 ? 60 * t[0] + t[1] : 0;
        } else {
          d.value = 0;
        }
      });
      data.avg_time_spent_last7 = data.avg_time_spent_last7.reverse();
    }
    return (
      <div className="row mt-3 mb-4">
        <div className="col-6 col-sm-6 col-md-12 mb-4 mt-3">
          <Heading size={6} className={"mb-2"}>
            Page Views/Visitor
          </Heading>
          <Metric
            {...data.page_views_per_visitor}
            graph={data.page_views_per_visitor_last7}
            size={"lg"}
            format={"0.00"}
            type={"other"}
          />
        </div>
        <div className="col-6 col-sm-6 col-md-12 mt-3">
          <Heading size={6} className={"mb-2"}>
            Avg Minutes/Visitor
          </Heading>
          <Metric
            {...data.avg_time_spent}
            graph={data.avg_time_spent_last7}
            size={"lg"}
            type={"time"}
          />
        </div>
      </div>
    );
  }
}

export default PageEngagement;
